import React from 'react';
import ColumnaBotoneraItem from '../../edicion/ColumnaBotoneraItem.js';
import ResultadoListaPartidos from '../../consulta/ResultadoListaPartidos.js';
import FilaPartidoFixture from './FilaPartidoFixture.js';
import * as UI from '../../constantes/UI.js';
import * as Funciones from '../../funciones/FuncionesFixture.js';
import * as FuncionesEquipo from '../../funciones/FuncionesEquipo.js';
import * as FuncionesFecha from '../../funciones/FuncionesFecha.js';
import styles from './TablaFechaFixtureGrupos.module.css';

/**
 * Tabla de partidos de una fecha de una etapa de grupos: partidos existentes
 * (solo lectura o en edición) y partidos faltantes (editables).
 */
const TablaFechaFixtureGrupos = (props) => {
  const titulo = props.titulo;
  const partidosFechaActual = props.partidosFechaActual || [];
  const partidosFaltantes = props.partidosFaltantes || [];
  const equipos = props.equipos;
  const torneo = props.torneo;
  const mostrarZona = props.mostrarZona;
  const todasLasFechasCompletas = props.todasLasFechasCompletas;
  const puedeEditar = props.puedeEditar;
  const partidosEnEdicion = props.partidosEnEdicion;
  const partidoGrabandose = props.partidoGrabandose;
  const erroresFilaPartido = props.erroresFilaPartido;
  const onPartidoElegido = props.onPartidoElegido;
  const onEditarPartido = props.onEditarPartido;
  const onEliminarPartido = props.onEliminarPartido;
  const onPartidoEnEdicionChange = props.onPartidoEnEdicionChange;
  const onGuardarEdicion = props.onGuardarEdicion;
  const onCancelarEdicion = props.onCancelarEdicion;
  const onPartidoChange = props.onPartidoChange;
  const onGuardarPartido = props.onGuardarPartido;
  const onCancelarPartido = props.onCancelarPartido;

  const mostrarOrdenPartido = !todasLasFechasCompletas;
  const mostrarFecha = todasLasFechasCompletas;
  const { esMobile } = UI.useUI();

  const renderFilaExistente = (partido) => {
    const enEdicion = !!partidosEnEdicion[partido.id];

    if (enEdicion) {
      return (
        <FilaPartidoFixture
          key={`edit-${partido.id}`}
          partido={partidosEnEdicion[partido.id]}
          equipos={equipos}
          torneo={torneo}
          mostrarEquipoLibre={true}
          mostrarZona={mostrarZona}
          zonaObligatoria={mostrarZona}
          mostrarOrdenPartido={mostrarOrdenPartido}
          mostrarFecha={mostrarFecha}
          mostrarResultados={true}
          esPartidoExistente={true}
          requiereFecha={false}
          esVuelta={false}
          isGrabando={partidoGrabandose === partido.id}
          onChange={(partidoActualizado) =>
            onPartidoEnEdicionChange(partido.id, partidoActualizado)
          }
          onGuardar={() => onGuardarEdicion(partidosEnEdicion[partido.id])}
          onCancelar={() => onCancelarEdicion(partido.id)}
          onPartidoElegido={onPartidoElegido}
          errores={erroresFilaPartido[partido.id] || []}
        />
      );
    }

    let resultado = '';
    if (partido.equipoLibre === false) {
      resultado =
        partido.resultadoLocal != null && partido.resultadoVisitante != null
          ? `${partido.resultadoLocal} - ${partido.resultadoVisitante}`
          : '-';
    }

    return (
      <tr key={partido.id}>
        {mostrarOrdenPartido && (
          <td className={styles.ordenPartido}>{partido.ordenPartido || ''}</td>
        )}
        {mostrarFecha && (
          <td className={styles.fecha}>
            {esMobile
              ? FuncionesFecha.CamposToDiaMes(partido.mesPartido, partido.diaPartido)
              : FuncionesFecha.CamposToFechaCorta(
                  partido.anioPartido,
                  partido.mesPartido,
                  partido.diaPartido
                )}
          </td>
        )}
        <td className={styles.equipoLocal}>
          {FuncionesEquipo.NombreEquipoTorneo(partido.equipoLocal, torneo)}
        </td>
        <td className={styles.resultado}>
          {partido.equipoLibre === true ? (
            <span>{resultado}</span>
          ) : onPartidoElegido ? (
            <ResultadoListaPartidos
              id={partido.id}
              local={partido.resultadoLocal}
              visitante={partido.resultadoVisitante}
              onPartidoElegido={onPartidoElegido}
            />
          ) : (
            <span>{resultado}</span>
          )}
        </td>
        <td className={styles.equipoVisitante}>
          {partido.equipoLibre ? (
            <i>Libre</i>
          ) : (
            FuncionesEquipo.NombreEquipoTorneo(partido.equipoVisitante, torneo)
          )}
        </td>
        {mostrarZona && (
          <td className={styles.zona}>{Funciones.NormalizarZona(partido.zona) || ''}</td>
        )}
        <ColumnaBotoneraItem
          idItem={partido.id}
          onEditarItem={onEditarPartido}
          onEliminarItem={onEliminarPartido}
          className={styles.botones}
        />
      </tr>
    );
  };

  return (
    <div className={styles.grupo}>
      <h4>{titulo}</h4>
      <table className={styles.tabla}>
        <colgroup>
          {mostrarOrdenPartido && <col className={styles.ordenPartido} />}
          {mostrarFecha && <col className={styles.fecha} />}
          <col className={styles.equipoLocal} />
          <col className={styles.resultado} />
          <col className={styles.equipoVisitante} />
          {mostrarZona && <col className={styles.zona} />}
          <col className={styles.botones} />
        </colgroup>
        <thead>
          <tr>
            {mostrarOrdenPartido && <th className={styles.ordenPartido}>#</th>}
            {mostrarFecha && <th className={styles.fecha}>Día</th>}
            <th className={styles.equipoLocal}>Local</th>
            <th className={styles.resultado}>Res</th>
            <th className={styles.equipoVisitante}>Visitante</th>
            {mostrarZona && <th className={styles.zona}>{esMobile ? 'Z.' : 'Zona'}</th>}
            <th className={styles.botones}></th>
          </tr>
        </thead>
        <tbody>
          {partidosFechaActual.map((partido) => renderFilaExistente(partido))}

          {puedeEditar &&
            partidosFaltantes.map((partido) => (
              <FilaPartidoFixture
                key={`faltante-${partido.idPartido}`}
                partido={partido}
                torneo={torneo}
                equipos={equipos}
                mostrarEquipoLibre={true}
                mostrarZona={mostrarZona}
                zonaObligatoria={mostrarZona}
                mostrarOrdenPartido={mostrarOrdenPartido}
                mostrarFecha={mostrarFecha}
                mostrarResultados={false}
                requiereFecha={false}
                esVuelta={false}
                isGrabando={partidoGrabandose === partido.idPartido}
                onChange={(partidoActualizado) =>
                  onPartidoChange(partido.idPartido, partidoActualizado)
                }
                onGuardar={() => onGuardarPartido(partido)}
                onCancelar={() => onCancelarPartido(partido)}
                onPartidoElegido={onPartidoElegido}
                errores={erroresFilaPartido[partido.idPartido] || []}
              />
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default TablaFechaFixtureGrupos;
